module.exports = __webpack_public_path__ + "static/media/politics.ae195e5e.png";